import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Volume2 } from "lucide-react";
import { api } from "../../lib/api";
import { playUrl } from "../../lib/narration";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";

const API = process.env.REACT_APP_BACKEND_URL;

export const VoicePicker = ({ value, onChange, style = "narrator", testId = "narrator-voice" }) => {
  const [voices, setVoices] = useState(null);
  const [fallback, setFallback] = useState("");

  useEffect(() => {
    api.get("/admin/voices").then((r) => { setVoices(r.data.voices); setFallback(r.data.default); }).catch(() => setVoices([]));
  }, []);

  const selected = value || fallback;
  return (
    <div data-testid="voice-picker" className="flex flex-wrap items-center gap-3">
      <Select value={selected} onValueChange={onChange} disabled={!voices?.length}>
        <SelectTrigger data-testid={`${testId}-select`} className="w-72 rounded-none border-slate-700 bg-slate-900 font-mono text-xs uppercase tracking-widest">
          <SelectValue placeholder={voices === null ? "Loading voices..." : "No voices available"} />
        </SelectTrigger>
        <SelectContent className="lab-dialog max-h-80">
          {(voices || []).map((v) => (
            <SelectItem key={v.id} value={v.id} data-testid={`${testId}-${v.id}`} className="font-mono text-xs uppercase tracking-widest">{v.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <button type="button" data-testid={`${testId}-preview`} disabled={!selected} onClick={() => playUrl(`${API}/api/admin/voice-preview?voice_id=${selected}&style=${style}`).catch(() => toast.error("Could not play this voice - check the ElevenLabs key or quota"))} className="lab-btn-ghost py-1.5">
        <Volume2 size={16} /> Preview voice
      </button>
    </div>
  );
};
